module.exports = __webpack_public_path__ + "static/media/Generic.4ae20c54.png";